// You can write more code here

/* START OF COMPILED CODE */

import EditorTileSprite from '../../EditorTileSprite';
import SimpleBreakableBlocker from '../../../components/platformer/SimpleBreakableBlocker';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class SmashableMarkerCrate extends EditorTileSprite {
  constructor(scene: Phaser.Scene, x?: number, y?: number, width?: number, height?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 47, y ?? 132, width ?? 94, height ?? 264, texture || 'game-all', frame ?? 'smashable-crate.png');

    // this (components)
    new SimpleBreakableBlocker(this);

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
